module.exports = "/images/compass.svg?f64797a8334e1d32bf3e077555d0da6d";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icons/compass.svg
// module id = tCz/
// module chunks = 0 1